import PropTypes from 'prop-types';
import {isEmpty} from 'lodash';
import {SortableContainer, SortableElement} from 'react-sortable-hoc';
import './SelectedComparableList.scss';
import ComparablePropertyAccordionContainer from './ComparablePropertyAccordion';


export const SelectedSortableProperty = SortableElement(({
  key, propertyId, position, index, active, comparableType, settings
}) => {
  return (
    <li key={`p.key${index}`} className="sortable-comparable">
      <ComparablePropertyAccordionContainer
        key={`${comparableType}-${propertyId}`}
        propertyId={propertyId}
        active={active}
        settings={settings}
        selected
        comparableType={comparableType}
        selectedView
        index={position}
      />
    </li>
  );
});

export const SelectedSortableProperties = SortableContainer(({featureFlags, featured, selected, settings, active, comparableType, ...props}) => {
  return (
    <ul {...props} className="sortable-comparable-list">
      {selected.map((propertyId, i) => (
        <SelectedSortableProperty
          key={propertyId}
          propertyId={propertyId}
          position={i}
          index={i}
          active={active}
          collection={featured.includes(propertyId) ? 0 : 1}
          comparableType={comparableType}
          settings={settings}
          featureFlags={featureFlags}
        />
      ))}
    </ul>
  );
});

export default function SelectedComparableList({comparableType, featureFlags, selected, featured, settings, active, onSortEnd}) {
    if (isEmpty(selected)) {
        return (
            <div className="no-selection">
                <div className="first-line">You have not yet added any comparable to your selected list.</div>
                <div className="rest-lines">
                    Add comparable by selecting properties from the 'Search Results' below. Once you have added more then
                    one property you can re-arrange the order of your selected list. The properties you add to this section
                    will be included in your final report.
                </div>
            </div>
        );
    }
    return (
        <SelectedSortableProperties
            featureFlags={featureFlags}
            selected={selected}
            featured={featured}
            settings={settings}
            active={active}
            helperClass="sortable-comparable-list"
            lockAxis="y"
            lockOffset={100}
            useWindowAsScrollContainer
            onSortEnd={({oldIndex, newIndex}) => {
                onSortEnd(oldIndex, newIndex);
            }}
            comparableType={comparableType}
            useDragHandle
        />
    );
}

SelectedComparableList.propTypes = {
  comparableType: PropTypes.string.isRequired,
  selected: PropTypes.array.isRequired,
  featureFlags: PropTypes.shape({}).isRequired,
  featured: PropTypes.array.isRequired,
  settings: PropTypes.object.isRequired,
  active: PropTypes.bool.isRequired,
  onSortEnd: PropTypes.func.isRequired,
};
